import { QuantifyVisualisationType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';
import { getVisibleDataPointsDefaultSize } from '.';
import { QuantifyReportDataPointBase } from '../store/types';

interface getDefaultSelectedDataPointsOptions {
  reportDataPoints: QuantifyReportDataPointBase[];
  visualisationType?: QuantifyVisualisationType;
  selectionCount?: number;
}

export function getDefaultSelectedDataPoints({
  reportDataPoints,
  visualisationType,
  selectionCount,
}: getDefaultSelectedDataPointsOptions): UUID[] {
  if (!reportDataPoints) {
    return [];
  }

  return reportDataPoints
    .slice(
      0,
      getVisibleDataPointsDefaultSize(visualisationType, selectionCount),
    )
    .map(({ id }) => id);
}
